import {
  BackAndNextButtons,
  type BackAndNextButtonsProps,
} from './BackAndNextButtons'
import { SkipButton } from './SkipButton'

type ButtonsSectionProps = BackAndNextButtonsProps & {
  showSkip?: boolean
  animateOut?: boolean
  setInAnimation?: (inAnimation: boolean) => void
}

export const ButtonsSection = ({
  disabled,
  onNext,
  disabledText = 'Please provide an answer to proceed.',
  showSkip = false,
  machineEvent,
  animateOut = false,
  setInAnimation,
}: ButtonsSectionProps) => (
  <>
    {showSkip && <SkipButton />}
    <BackAndNextButtons
      onNext={onNext}
      disabled={disabled}
      disabledText={disabledText}
      machineEvent={machineEvent}
      animateOut={animateOut}
      setInAnimation={setInAnimation}
    />
  </>
)
